__webpack_require__.p = "https://prod.eu.safer.whs.amazon.dev/";